<template>
	<footer class="an-table-footer">
		<div class="columns">
			<div class="column">
				<nav class="pagination is-small" role="navigation" aria-label="pagination">
					<a class="pagination-previous" v-on:click="prevPage" v-if="this.pageNumber > 0">Previous</a>
					<a class="pagination-next" v-on:click="nextPage()" v-if="this.pageNumber < this.pageCount-1">Next page</a>
					<ul class="pagination-list">
						<li><a class="pagination-link" aria-label="Go to page 1" v-if="this.pageNumber >= 2" v-on:click="goToPage(0)">1</a></li>
						<li><span class="pagination-ellipsis" v-if="this.pageNumber >= 2">&hellip;</span></li>
						<li>
							<a class="pagination-link" 
								:aria-label="'Go to page ' + this.pageNumber" 
								v-if="this.pageNumber > 0"
								v-on:click="goToPage(pageNumber-1)">
									{{ this.pageNumber }}
							</a>
						</li>
						<li><a class="pagination-link is-current" :aria-label="'Page ' + this.pageNumber + 1" aria-current="page">{{ this.pageNumber + 1 }}</a></li>
						<li>
							<a class="pagination-link" 
								:aria-label="'Go to page ' + this.pageNumber + 2"
								v-on:click="goToPage(pageNumber+1)"
								v-if="this.pageNumber < this.pageCount - 1">
									{{this.pageNumber + 2 }}
							</a>
						</li>
						<li><span class="pagination-ellipsis" v-if="this.pageNumber < this.pageCount - 2">&hellip;</span></li>
						<li>
							<a class="pagination-link" 
								:aria-label="'Go to page ' + this.pageCount" 
								v-on:click="goToPage(pageCount-1)"
								v-if="this.pageNumber < this.pageCount - 2">
									{{ this.pageCount }}
							</a>
						</li>
					</ul>
				</nav>
				<div class="display-info">
					<p>
						Displaying page {{ pageNumber+1 }} of {{ pageCount }}, items {{ itemStart }} to {{ itemEnd }} of {{ this.itemCount }}.
					</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
    props: {
		value: Number,
        itemCount: Number,
        pageSize: Number
    },
    data() {
        return {
            pageNumber: this.value
        }
    },
    methods: {
		nextPage() {
			this.$emit('input', this.pageNumber = this.pageNumber +1)
			window.scrollTo(0,0)
		},
		prevPage() {
            this.$emit('input', this.pageNumber = this.pageNumber - 1)
			window.scrollTo(0,0)
		},
		goToPage(page) {
            this.$emit('input', this.pageNumber = page)
			window.scrollTo(0,0)
        }
    },
    computed: {
		pageCount() {
			const l = this.itemCount, s = this.pageSize
			return Math.ceil(l/s);
        },
        itemStart() {
			if (this.pageNumber === 0) { return 1 }
			return this.pageNumber * this.pageSize + 1
		},
		itemEnd() {
			if (this.pageNumber === 0) { 
				const len = this.itemCount
				if (len < this.pageSize) { return len}
				return this.pageSize 
			}
			
			let items = this.itemCount
			if (items < this.pageSize) { return this.pageNumber * this.pageSize + items }
			return this.pageNumber * this.pageSize + this.pageSize
		}
    }
}
</script>
